//M10-11344 Po related design changes
import { Tab } from "@headlessui/react";
import { Fragment } from "react";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import ViewPo from "./ViewPo";
import { useDispatch } from "react-redux";
import { usePoHandlers } from "./PoController";
import PoGenerate from "./PoGenerate";
import { getAllCompanyDetails } from "src/services/company-api";
import { poActions } from "src/context/po-slice";
import InvoiceLayout from "src/pages/invoice-master/invoice-layout.component";
import StockistBlockTab from "./StockistBlockRevoke/StockistBlock";
import OrderTypeException from "./OrderTypeException/OrderTypeException";
import MarginTypeException from "./MarginTypeException/MarginTypeException"; //M10-15933
import StockPosition from "./StockPosition/StockPosition";
import { fineGrainedPermissionsKeys } from "src/constants/permission";
import usePermission from "src/hooks/usePermission";
import Button from "../../components/Button";
import UploadIcon from "src/assets/upload.svg";
import OrderTypeExceptionForm from "./OrderTypeException/order-type-exception-form.component";

const PoHomeScreen = () => {
    const dispatch = useDispatch();
    const { tabIndex } = useParams();
    const [addNew, setAddNew] = useState({
        viewPO: false,
        poGenerate: false,
        stockistBlock: false,
        orderTypeException: false
    })

    const { hasPermission: viewPODetailsPermission, loading: isViewPermissionLoading } = usePermission({
        module: fineGrainedPermissionsKeys.PURCHASEORDER.VIEWPODETAILS.module,
        action: fineGrainedPermissionsKeys.PURCHASEORDER.VIEWPODETAILS.action,
    });

    const { hasPermission: poGeneratePermission, loading: isPoGeneratePermissionLoading } = usePermission({
        module: fineGrainedPermissionsKeys.PURCHASEORDER.POGENERATE.module,
        action: fineGrainedPermissionsKeys.PURCHASEORDER.POGENERATE.action,
    });

    const { hasPermission: stockistBlockRevokePermission, loading: isStockistBlockPermissionLoading } = usePermission({
        module: fineGrainedPermissionsKeys.PURCHASEORDER.STOCKISTBLOCKREVOKE.module,
        action: fineGrainedPermissionsKeys.PURCHASEORDER.STOCKISTBLOCKREVOKE.action,
    });

    const { hasPermission: orderTypeExceptionPermission, loading: isOrderTypeExcPermissionLoading } = usePermission({
        module: fineGrainedPermissionsKeys.PURCHASEORDER.ORDERTYPEEXCEPTION.module,
        action: fineGrainedPermissionsKeys.PURCHASEORDER.ORDERTYPEEXCEPTION.action,
    });
    //M10-15933
    const { hasPermission: marginTypeExceptionPermission, loading: isMarginTypeExcPermissionLoading } = usePermission({
        module: fineGrainedPermissionsKeys.PURCHASEORDER.MARGINTYPEEXCEPTION.module,
        action: fineGrainedPermissionsKeys.PURCHASEORDER.MARGINTYPEEXCEPTION.action,
    });
    //M10-15933

    const { hasPermission: stockPositionPermission, loading: isStockPositionPermissionLoading } = usePermission({
        module: fineGrainedPermissionsKeys.PURCHASEORDER.STOCKPOSITION.module,
        action: fineGrainedPermissionsKeys.PURCHASEORDER.STOCKPOSITION.action,
    });

    const isPermissionsLoading =
        isViewPermissionLoading ||
        isPoGeneratePermissionLoading ||
        isStockistBlockPermissionLoading ||
        isOrderTypeExcPermissionLoading ||
        isMarginTypeExcPermissionLoading || //M10-15933
        isStockPositionPermissionLoading;

    let tabs = [
        {
            title: "View PO details",
            component: < ViewPo />,
            condition: !isViewPermissionLoading && viewPODetailsPermission,
            showBulkUpload: false,
            showAddNew: false
        },
        {
            title: "PO Generate",
            component: <PoGenerate />,
            condition: !isPoGeneratePermissionLoading && poGeneratePermission,
            showBulkUpload: false,
            showAddNew: false
        },
        {
            title: "Stockist Block-Revoke",
            component: < StockistBlockTab />,
            condition: !isStockistBlockPermissionLoading && stockistBlockRevokePermission,
            showBulkUpload: false,
            showAddNew: false
        },
        {
            title: "Order Type Exception",
            component: <OrderTypeException />,
            condition: !isOrderTypeExcPermissionLoading && orderTypeExceptionPermission,
            showBulkUpload: true,
            showAddNew: true
        },
        //M10-15933
        {
            title: "Margin Type Exception",
            component: <MarginTypeException />,
            condition: !isMarginTypeExcPermissionLoading && marginTypeExceptionPermission,
            showBulkUpload: false,
        },
        //M10-15933
        {
            title: "Stock Position",
            component: <StockPosition />,
            condition: !isStockPositionPermissionLoading && stockPositionPermission,
            showBulkUpload: false,
        },
    ];

    const filteredTabs = useMemo(() => {
        return (tabs || []).filter((tab) => tab.condition !== false);
    }, [tabs, isPermissionsLoading]);

    const {
        fetchState,
    } = usePoHandlers();

    useEffect(() => {
        getAllCompanyDetails()
            .then((res) => dispatch(poActions.setPoFiltersData({ key: "company", value: res.data })))
            .catch((err) => console.log(err));
        fetchState
    }, [])

    return (
        <InvoiceLayout>
            <header className="flex flex-col justify-between py-5 mx-auto max-h-[100vh]">
                <div className="flex justify-between px-[3.75rem]">
                    <div className="">
                        <h1 className="text-[#49484C] font-bold text-[2rem]">PO Details</h1>
                    </div>
                </div>

                <Tab.Group defaultIndex={Number(tabIndex) || 0}>
                    {({ selectedIndex }) => (
                        <>
                            <Tab.List className="flex items-center justify-between px-[3.75rem] mb-[1.16rem] mt-2 border-b-[1px] border-b-[#E9E9E9] shadow-md">
                                <div className="flex">
                                    {filteredTabs.map((item: any) => (
                                        <Tab key={item.title} as={Fragment}>
                                            {({ selected }: { selected: boolean }) => (
                                                <div
                                                    className={`relative inline-block cursor-pointer -bottom-[1px] px-4 py-3 font-semibold text-sm border-b-2 hover:border-b-[#586AF5] hover:text-[#586af5] ${selected
                                                        ? "text-[#586af5] border-b-[#586AF5]"
                                                        : "text-[rgba(0,0,0,0.4)] border-b-transparent"
                                                        }`}
                                                >
                                                    {item.title}
                                                </div>
                                            )}
                                        </Tab>
                                    ))}
                                </div>

                                <div className="flex gap-2">
                                    {filteredTabs[selectedIndex]?.showBulkUpload && (
                                        <Button
                                            onClick={() =>
                                                dispatch(
                                                    poActions.setBulkUploadModalState({
                                                        key: "orderTypeExcBulk",
                                                        value: true,
                                                    })
                                                )
                                            }
                                            className="gap-2 border hover:bg-gray-100"
                                        >
                                            <img src={UploadIcon} alt="Upload" width={12} height={12} />
                                            Bulk Upload
                                        </Button>
                                    )}

                                    {filteredTabs[selectedIndex]?.showAddNew && (
                                        <Button
                                            onClick={() =>
                                                setAddNew((prev) => ({
                                                    ...prev,
                                                    orderTypeException: true,
                                                }))
                                            }
                                            className="gap-2 bg-[#7F56D9] text-white"
                                        >
                                            Add New
                                        </Button>
                                    )}
                                </div>
                            </Tab.List>
                            <Tab.Panels>
                                {filteredTabs.map((item: any) => (
                                    <Tab.Panel className="px-[3.75rem]" key={item.title}>
                                        {item.component}
                                    </Tab.Panel>
                                ))}
                            </Tab.Panels>
                        </>
                    )}
                </Tab.Group>
            </header>

            {addNew.orderTypeException && <OrderTypeExceptionForm onClose={()=>setAddNew((prev)=>({...prev, orderTypeException:false}))}/>}
        </InvoiceLayout>
    );
};

export default PoHomeScreen;
//M10-11344 Po related design changes